import { render, staticRenderFns } from "./HistoryAnomalyDetection.vue?vue&type=template&id=0ed7d3ca&"
import script from "./HistoryAnomalyDetection.vue?vue&type=script&lang=ts&"
export * from "./HistoryAnomalyDetection.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryAnomalyDetection.vue?vue&type=style&index=0&id=0ed7d3ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports